document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-shuffle-products="true"]').forEach(function (grid) {
    const items = Array.from(grid.children);

    // Keep the collection cover card (first item) fixed in place
    const coverCard = items.find(function (el) {
      return el.classList.contains('collection__cover');
    });
    const productItems = items.filter(function (el) {
      return !el.classList.contains('collection__cover');
    });

    // Fisher-Yates shuffle
    for (let i = productItems.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [productItems[i], productItems[j]] = [productItems[j], productItems[i]];
    }

    // Re-append: cover card first (if present), then shuffled products
    if (coverCard) {
      grid.appendChild(coverCard);
    }
    productItems.forEach(function (item) {
      grid.appendChild(item);
    });
    
    grid.classList.add('shuffle-ready'); // reveal once shuffled

  });
});